export class District {
    constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly city: string,
    ) {}
}
